export default __webpack_public_path__ + "static/media/green_spritesheet.8458fc87.png";